/**
 * Determines if a value is a member of an enum. Note: enums should be defined
 * with underlying strings. See https://stackoverflow.com/a/76736671/29805 .
 */
export default function isEnumMember<E>(
  value: unknown,
  enumArg: Record<string | number | symbol, E>
): value is E {
  return (Object.values(enumArg) as unknown[]).includes(value);
}
